import React, { useRef } from 'react';
import IconButton from '@material-ui/core/IconButton';
import SarasHotKeys from '../../../notifications/SarasHotKeys';

const SarasIconButton =(props)=>{
    const btn = useRef();
    
    const onHotkeyPress = (e) => {
        btn.current.click();
    }

    return(
        <SarasHotKeys ksc={props.ksc} onHotKey={onHotkeyPress} tooltip={props.tooltip}>
            <IconButton 
                ref={btn}
                color={props.color}
                aria-label={props.label}
                onClick={props.onclick}
                edge={props.edge}
                className={props.className}
                component="span"
            >
                {props.children}
            </IconButton>
        </SarasHotKeys>
    )
}

export default SarasIconButton